import createQuestion from "./createQuestion";
import editQuestion from "./editQuestion";
import deleteQuestion from "./deleteQuestion";

const checkQuestions = async (savedVoting, updatedVoting) => {
	const savedIds = savedVoting.questions.reduce(
		(acc, question) => ({ ...acc, [question.id]: true }),
		{}
	);

	if (savedVoting.questions) {
		for (const savedQuestion of savedVoting.questions) {
			if (updatedVoting.questions[savedQuestion.id]) {
				await editQuestion(
					updatedVoting.questions[savedQuestion.id],
					savedQuestion,
					savedQuestion.id,
					savedVoting.id,
					savedVoting
				);
			}
			if (!updatedVoting.questions[savedQuestion.id]) {
				await deleteQuestion(savedQuestion.id);
			}
		}
	}
	if (updatedVoting.questions) {
		for (const indexQuestionKey in updatedVoting.questions) {
			if (!savedIds[indexQuestionKey]) {
				await createQuestion(
					updatedVoting.questions[indexQuestionKey],
					savedVoting.id,
					indexQuestionKey
				);
			}
		}
	}
};
export default checkQuestions;
